import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormControlComponent } from '../form-control.component';
import { FormControl } from '../form-control.model';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { FormControlColorPickerComponent } from '../form-control-color-picker/form-control-color-picker.component';

@Component({
	selector: 'wncm-form-control-text-color-picker',
	templateUrl: './form-control-text-color-picker.component.html',
	styleUrls: ['../form-control.component.scss', './form-control-text-color-picker.component.scss']
})
export class FormControlTextColorPickerComponent extends FormControlComponent {
	@ViewChild('colorPicker', { static: true }) colorPicker: FormControlColorPickerComponent;

	@Input()
	displayHint: boolean;

	@Input()
	ctype: string;

	@Input()
	iconName: string;

	@Input()
	max: string;

	@Input()
	min: string;

	@Input()
	appearance = 'outline';

	@Input()
	readOnly: boolean;

	@Input()
	controlColor: FormControl;

	public color = '#00000';

	constructor() {
		super();
		if (this.readOnly) {
			this.control.disable();
		}
	}

	openColorPicker() {
		this.colorPicker.toggleColors();
	}

	setColor(color: string) {
		this.color = color;
		this.controlColor.setValue(color.replace('#', ''));
	}
}
